import React, { FC } from 'react';
import FixedPageLayout from '../../../components-library/layouts/FixedPageLayout';
import { useTranslation } from 'react-i18next';
import TrustLabel from '../../../components-library/labels/TrustLabel';
import CustomerInfoSection from '../../../components-library/checkout/sections/CustomerInfoSection';
import PaymentInfoSection from '../../../components-library/checkout/sections/PaymentInfoSection';
import InvoiceInfoSection from '../../../components-library/checkout/sections/InvoiceInfoSection';
import { SCREENS } from '../../../services/exports/Constants';
import Section from '../../../components-library/checkout/sections/Section';
import GiftCardsCheckoutScreen from './GiftCardsCheckoutScreen';
import PayButton from '../../../features/gift-cards/components/PayButton';
import useRouter from '../../../hooks/navigation/useRouter';
import useStorefront from '../../../hooks/storefront/useStorefront';
import useStorefrontRouter from '../../../modules/storefront/hooks/useStorefrontRouter';
import { StorefrontPages } from '../../../modules/storefront/exports/Enums';
import { useGiftCardsCheckoutErrors } from '../../../hooks/payment/useGiftCardCheckout';
import OrderPaymentScreen from '../../checkout/OrderPaymentScreen';
import { useGiftCardsBasket } from '../../../hooks/basket/useGiftCardBasket';
import useAppMethods from '../../../hooks/utility/useAppMethods';
import useGiftCardExcludedPaymentMethods from '../../../features/gift-cards/hooks/useGiftCardExcludedPaymentMethods';

const DesktopGiftCardsCheckoutScreen: FC = () => {
  const { t } = useTranslation(undefined, { keyPrefix: 'Pages:Checkout:OrderPaymentScreen' });
  const { t: tPayBtn } = useTranslation(undefined, { keyPrefix: 'Components:Payment:Buttons:PayButton' });

  const { navigate } = useRouter();
  const { navigate: storeFrontNavigate } = useStorefrontRouter();
  const { isStorefront } = useStorefront();
  const { validationErrors } = useGiftCardsCheckoutErrors();
  const { total } = useGiftCardsBasket();
  const { formatCurrency } = useAppMethods();
  const excludedPaymentMethods = useGiftCardExcludedPaymentMethods();

  const onReturn = (): void => {
    if (isStorefront) {
      return storeFrontNavigate(StorefrontPages.GiftCards);
    }

    navigate({ web: { to: SCREENS.HOME_SCREEN } });
  };

  return (
    <FixedPageLayout
      hasHeader={false}
      leftColumn={
        <OrderPaymentScreen.LeftColumn onReturn={onReturn}>
          <TrustLabel className="my-md" />
          <CustomerInfoSection show validationErrors={validationErrors} />
          <InvoiceInfoSection show validationErrors={validationErrors} />
          <PaymentInfoSection show excludedPaymentMethods={excludedPaymentMethods} />
        </OrderPaymentScreen.LeftColumn>
      }
      rightColumn={
        <div className="flex flex-col space-y-md relative overflow-y-scroll overscroll-contain scrollbar-hide h-full">
          <Section
            show
            title={t('sections.order_summary')}
            className="!p-md space-y-md bg-white !rounded-lg"
            titleClassName="!text-brand-text-primary !text-md"
            containerClassName="p-md"
          >
            <GiftCardsCheckoutScreen.GiftCardRow />
            <GiftCardsCheckoutScreen.DeliveryRow />
            <GiftCardsCheckoutScreen.TotalRow />
          </Section>
          <div className="p-md !mt-auto bg-white">
            <PayButton title={tPayBtn('pay_now', { amount: formatCurrency(total) })} />
          </div>
        </div>
      }
    />
  );
};

export default DesktopGiftCardsCheckoutScreen;
